export const DIMENSION_CLASSES = 'min-w-[min(600px,calc(100vw-50px))] max-w-[min(600px,calc(100vw-50px))]';
